
// const BasedUrl = "https://server.cbthost.com/api/";
// const FileServer = "https://server.cbthost.com/api/";
// const ServerImage = "https://server.cbthost.com/";
// const ServerBased = "https://server.cbthost.com/";


const BasedUrl = "https://cbt-lms.cbthost.com/api/v1/";
const FileServer = "https://cbt-lms.cbthost.com/api/v1/";
const ServerImage = "https://cbt-lms.cbthost.com/";
const ServerBased = "https://cbt-lms.cbthost.com/api/v1/";
const blog = "https://server-blog.gandgcollege.com.ng/api/";
const wp = "https://wp.gandgcollege.com.ng/wp-json/wp/v2/posts";

const AdminCreateUnit = BasedUrl+"admin/admin_create_unit";
const AdminGetUnit = BasedUrl+"admin/admin_get_unit";


// api key management 

const create_key = BasedUrl + "api_key/create_key";
const get_key = BasedUrl + "api_key/get_key";
const revoke = BasedUrl + "api_key/revoke/";

// payments 
const create_invoice = BasedUrl + "payment/create-invoice";
const payment_history = BasedUrl + "payment/payment-history";
const confirm_bank_transfer = BasedUrl + "payment/confirm-bank-transfer/";
const subscription = BasedUrl + "subscription/users";
const Addsubscription = BasedUrl + "subscription/add-user";
const generate_token = BasedUrl + "subscription/generate-token";

// authetication

const LoginUrl = BasedUrl + "auth/login";
const SignUpUrl = BasedUrl + "auth/register";
const gmailLogin = BasedUrl + "auth/google-login";
// const forgotPassword = BasedUrl + "forgotPassword";
// const ResetPasswordUrl = BasedUrl + 'forgot-password';

// Change these lines in serverurl.js

const ResetPasswordUrl = BasedUrl + 'auth/forgot-password';        // was 'forgot-password'
const ResetChangePasswordUrl = BasedUrl + 'auth/reset-password';   // was 'confirm-forgot-password'
const ValidateTokenUrl = BasedUrl + 'auth/validate-reset-token';   // new endpoint (we'll add below)

const profileData = BasedUrl + "admin/profile_data";
const updateProfile = BasedUrl + "admin/update_profile";
//  const ResetChangePasswordUrl = BasedUrl + "confirm-forgot-password";
//  const ValidateTokenUrl = BasedUrl + "password-reset/validate-token";


// student urls

const VerifyPublicCbtPassCode = BasedUrl+"cbt_pass_code/cbt_pass_code_public_verify";
const VerifyPublicGetCbtPassCode = BasedUrl+"cbt_pass_code/cbt_pass_code_get_public_verify/";
const VerifyPublicGetCbtPassCodeQr = BasedUrl+"cbt_pass_code_get_public_verify/";
const PublicMassCbtQuestionGet = BasedUrl + "question/public_mass_cbt_question_get/"; 
const StudentClearAnswer = BasedUrl + "question/student_clear_answer/"; 
const clearAnswer = BasedUrl + "question/student_clear_answer/"; 
const StudentClearTheory = BasedUrl + "question/student_clear_theory/"; 


// 




// cbt_data_id
const CbtDataIdCreateCbt = BasedUrl+"cbt_pass_code/create_cbt_pass_code";
const CbtDataIdGetCbt = BasedUrl+"cbt_pass_code/get_cbt_pass_code";
const CbtDataIdPrivateCbtDataVerify = BasedUrl+"cbt_pass_code/cbt_pass_code_private_verify/cbt_pass_code=";
const CbtPermitVerification = BasedUrl + "cbt_pass_code/cbt_permit_verification";
const TakeCbtPermitVerification = BasedUrl + "cbt_pass_code/take_cbt_permit_verification";
const CbtTestData = BasedUrl + "cbt_pass_code/permit_verification_data";
const Deletecbtdata = BasedUrl + "cbt_pass_code/delete_cbtdata";
const UpdateCbtDataId = BasedUrl + "cbt_pass_code/update_cbtdata_id";
const Cbt_Csv = BasedUrl + "cbt_pass_code/cbt_csv/";
const CbtStudentImports = BasedUrl + "cbt_pass_code/cbt_student_imports";
const CbtSecurityPhrases = BasedUrl + "cbt_pass_code/cbt-security-phrases";
const CbtTransferQuestions = BasedUrl + "";
const security_phrase_create = BasedUrl + "cbt_pass_code/security_phrase_create";
const security_phrase_get = BasedUrl + "cbt_pass_code/security_phrase_get";
const transfer_questions = BasedUrl + "cbt_pass_code/transfer_questions";
const incoming_transfer_data = BasedUrl + "cbt_pass_code/incoming_transfer_data";

// cbt question and answers

const CbtQuestionCreate = BasedUrl+"question/create_cbt_question";
const  MassPrivateQuestionGet = BasedUrl+"question/mass_private_question_get/";
const  MassPrivateQuestionExport = BasedUrl+"question/mass_private_question_export/";
const SinglePrivateQuestionGet = BasedUrl+"question/single_private_question_get";
const SinglePrivateAnswerGet = BasedUrl + "question/single_private_single_answer_get/";
const CreateCbtQuestionAnswer = BasedUrl+"question/answer/create_cbt_question_answer";
const update_cbt_question_answer = BasedUrl + "question/answer/update_cbt_question_answer";
const StudentAnswerSubmit = BasedUrl+"question/student_answer_submit";
const submitAnswer = BasedUrl+"question/student_answer_submit";
const StudentTheorySubmit = BasedUrl+"question/student_theory_submit";
const theory_submit = BasedUrl+"question/student_theory_submit";
const StudentGradeSubmit = BasedUrl+"question/student_grade_submit";
const FinalizedGrade = BasedUrl+"question/finalized_grade";
const gradeStudent = BasedUrl+"question/finalized_grade";
const delete_single_answer = BasedUrl + "question/answer/delete_single_answer";
const delete_cbt_question = BasedUrl + "question/delete_cbt_question";
const update_cbt_question = BasedUrl + "question/update_cbt_question";
const test_result = BasedUrl + "question/test_result/";
const mass_test_result = BasedUrl + "question/mass_test_result";
const mass_question_insert = BasedUrl + "question/insert_questions";

// manual grading of student 
const get_question_manual_grade = BasedUrl + "question/private_mass_cbt_question_get";
const UpdateScoreUrl = BasedUrl + "question/custom_score";



// cbt draft img
const upload_file = FileServer + "upload_file";
const private_all_asset = FileServer + "private_all_asset";
const ImgFile = ServerImage + "img_asset/";
const add_diagram_to_question = FileServer + "add_diagram_to_question";
const diagram_question = FileServer + "diagram_question/";
const delete_diagram_question = FileServer + "delete_diagram_question";
const update_diagram_question = FileServer + "update_diagram_question";
const private_delete_asset = FileServer + "private_delete_asset";

// blogs
const PostTitles = blog + "blog_post";
const SinglePost = blog + "blog/post/";



// server file fast api

const upload_docx = "https://task.cbthost.com/upload/";
const job_status = "https://task.cbthost.com/upload";
const job_uploads = "https://task.cbthost.com/uploads";
// serverurl.js - Add these endpoints


// serverurl.js - Add these endpoints
export const CbtSecurityPhraseCreate = `${ServerBased}/cbt/security-phrases/create`;
export const CbtSecurityPhraseGet = `${ServerBased}/cbt/security-phrases`;
export const CbtTestResults = `${ServerBased}/cbt/test-results`;
export const CbtStudentResults = `${ServerBased}/cbt/student-results`;
export const CbtCbtStudents = `${ServerBased}/cbt/my-cbts/students`;
export const CbtValidateSecurityPhrase = `${ServerBased}/cbt/validate-security-phrase`;



export const verifyPasscodeUrl = BasedUrl + 'verify-passcode';
export const participantLoginUrl = BasedUrl + 'participant-login';


export {AdminCreateUnit, AdminGetUnit, 
    CbtDataIdGetCbt, CbtDataIdCreateCbt, 
    CbtDataIdPrivateCbtDataVerify, CbtQuestionCreate, 
    MassPrivateQuestionGet, SinglePrivateQuestionGet, 
    CreateCbtQuestionAnswer, SinglePrivateAnswerGet,
    VerifyPublicCbtPassCode,
    VerifyPublicGetCbtPassCode, PublicMassCbtQuestionGet,
     CbtPermitVerification, TakeCbtPermitVerification,
     upload_file, FileServer, private_all_asset,
      ImgFile, LoginUrl, SignUpUrl,
      PostTitles, SinglePost,
      CbtTestData,
      StudentAnswerSubmit,
      StudentGradeSubmit, 
      gmailLogin,
      updateProfile,
      profileData,
      Deletecbtdata,
      UpdateCbtDataId,
      ServerImage,
      add_diagram_to_question,
      diagram_question,
      delete_diagram_question,
      update_cbt_question,
      update_diagram_question,
      delete_single_answer,
      delete_cbt_question,
      update_cbt_question_answer,
      private_delete_asset,
      FinalizedGrade,
      test_result,
      Cbt_Csv,
      ServerBased, wp,
      StudentClearAnswer,
      StudentClearTheory,
      StudentTheorySubmit,
      mass_test_result,
      get_question_manual_grade,
      ResetPasswordUrl,
    //   forgotPassword,
      ResetChangePasswordUrl,
      CbtStudentImports,CbtSecurityPhrases, CbtTransferQuestions,
      ValidateTokenUrl, submitAnswer, clearAnswer, 
      theory_submit, gradeStudent, UpdateScoreUrl, VerifyPublicGetCbtPassCodeQr,
      security_phrase_create, transfer_questions, security_phrase_get, incoming_transfer_data, create_key, get_key, revoke,
      create_invoice,
payment_history,
confirm_bank_transfer,BasedUrl,
upload_docx, job_status, job_uploads, mass_question_insert, MassPrivateQuestionExport
}